import { toRaw } from 'vue'
import i18n from '@/plugins/translationsPlugin'
import errorParser from '@/utils/errorParser'
import { logService } from '@nsftx/seven-client-retail-utils'
import { useFetchBetslip } from '@nsftx/seven-client-retail-vue-sgp'
import { useNotificationsStore, useSpinnerStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import { NXGDSNotificationVariants } from '@nsftx/seven-nxg-design-system'
import { useSlipCheckStore } from '@/stores/slip-check/slipCheckStore'

const LOG_PREFIX = '[slipCheckService]'
const SLIP_CHECK_ERROR_NOTIFICATION_ID = 'slip_check_notification_error'
const { t } = i18n.global

const checkAndShowSlipDetails = async (barcode: string, showSpinner = false) => {
  const slipCheckStore = useSlipCheckStore()
  const spinnerStore = useSpinnerStore()
  const notificationsStore = useNotificationsStore()
  const { betslip, fetchBetslip, error, errorDetails } = useFetchBetslip()

  logService.info(`${LOG_PREFIX} Slip code scanned`, {
    slip_code: barcode,
    code: 'SS_SLIP_CODE_SCAN',
  })

  notificationsStore.closeNotificationById(SLIP_CHECK_ERROR_NOTIFICATION_ID)

  if (showSpinner) {
    spinnerStore.showSpinner()
  }

  await fetchBetslip(barcode)

  spinnerStore.closeSpinner()

  if (betslip.value) {
    slipCheckStore.slipId = barcode
    slipCheckStore.closeSlipCheckModal()
    slipCheckStore.showSlipCheckDetailsModal()
  } else {
    logService.warn('[slipCheckService] Failed to check slip code', {
      slip_code: barcode,
      code: 'SS_SLIP_CHECK_CODE_FORM_ERROR',
      ...errorParser.parseUpstream(error.value),
      details: toRaw(errorDetails.value),
    })
    notificationsStore.showNotification({
      id: SLIP_CHECK_ERROR_NOTIFICATION_ID,
      text: [t('slip_check_error')],
      variant: NXGDSNotificationVariants.error,
    })
  }
}

export { checkAndShowSlipDetails }
